<template>
  <div
    v-if="visible"
    class="result-card-warning__card-info"
    :class="'result-card-warning--' + color"
  >
    <md-tooltip
      v-if="dismissButtonVisible"
      md-direction="bottom"
    >
      {{ title }}: {{ text }}
    </md-tooltip>
    <div class="result-card-warning__card-info-icon-content">
      <md-icon
        :md-src="iconTypes[icon]"
        class="icon-attention"
      />
    </div>
    <div class="result-card-warning__card-info-text-content">
      <p>{{ title }}</p>
      <span>{{ text }}</span>
    </div>
    <div
      v-if="dismissButtonVisible"
      class="ignore-button-container"
    >
      <md-button
        class="btn btn-primary result-card-warning__filter-button result-card-warning__filter-button-right"
        @click="hide()"
      >
        <md-tooltip md-direction="top">
          Clique aqui para ocultar o aviso.
        </md-tooltip>Dispensar
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResultCardWarning',
  props: {
    color: {
      default: 'yellow',
      type: String
    },
    icon: {
      type: String,
      default: 'attention'
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    dismissButtonVisible: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    iconTypes: {
      attention: '/static/images/icon-attention.svg',
      success: '/static/images/icon-correct-success.svg'
    },
    visible: true
  }),
  methods: {
    hide () {
      this.visible = false
    }
  }
}
</script>


<style lang="scss">
@import "../../../../../static/stylesheets/variables";

.result-card-warning {
  &__card-info {
    background-color: white;
    text-transform: uppercase;
    padding: 15px;
    border-radius: 5px;
    margin-left: 15px;
    display: flex;
    cursor: default;
    border: 2px solid white;
    overflow: hidden;
    position: relative;

    &-count-available-results {
      background-color: rgba(127, 26, 84, 0.1);
      padding: 12px;
      border-radius: 5px;
      margin: auto;

      p {
        font-size: 19px;
        color: $brand-primary;
        font-weight: 500;
      }
    }

    &-text-content {
      padding: 5px;
      line-height: 16px;
      margin-top: auto;
      margin-left: 0.5em;

      p {
        font-size: 12px;
        font-weight: 500;
        color: #7a7a7a;
      }

      span {
        font-size: 11px;
        color: #b7b7b7;
        font-weight: 500;
      }
    }

    &-icon-content {
      width: 2em;
      margin: auto;

      .icon-attention {
        fill: white;
        width: 1.6em;
        height: 1.1em;
        padding-right: 8px;

        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          /* IE10 & IE11 CSS styles go here */
          margin-top: 10px;
        }
      }
    }

    .ignore-button-container {
      right: -100%;
      color: #fff;
      height: 100%;
      bottom: 0%;
      text-align: center;
      position: absolute;
      transition: right 0.5s ease;
      width: 100%;
      display: flex;

      button {
        align-self: center;
        margin-left: auto;
        margin-right: 1em;
        -webkit-box-shadow: 0px 0px 204px 120px rgba(255, 255, 255, 1);
        -moz-box-shadow: 0px 0px 204px 120px rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 204px 120px rgba(255, 255, 255, 1);
      }
    }

    &:hover .ignore-button-container {
      right: 0%;
    }
  }

  &--yellow {
    &:hover {
      border: 2px solid #f5a623;
      box-sizing: border-box;
    }
  }

  &--green {
    &:hover {
      border: 2px solid #219653;
      box-sizing: border-box;
    }
  }
}
</style>
